import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Typography from '../../layouts/theme-onboarding/Typography';
import PreviousInformation from './confirm/PreviousInformation';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { initStep3Data } from '../../utils/object/Signup';
import { validatePhone, validateName, validateSalary, validateCompany } from '../../utils/regex/Regex';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import CheckIcon from '@mui/icons-material/Check';
import Stack from '@mui/material/Stack';
import Color from '../../layouts/Color';
import { graphGetAllOccupations, graphGetAllPositions } from '../../services/Onboarding';
import { relationShip } from '../../constant/CustomerReferenceType';
import { MoneyFormatCustom } from '../../utils/function/Function';

const info = { textAlign: 'left' };
const container = { mt: 1 };
const iconColor = { color: Color.Main };
const formWidth = { minWidth: 120 };

export default function Confirm(props) {
  const [refphoneErrorText, setRefPhoneErrorText] = useState('');
  const [refNameErrorText, setRefNameErrorText] = useState('');
  const [salaryErrorText, setSalaryErrorText] = useState('');
  const [companyErrorText, setCompanyErrorText] = useState('');
  const [step3, setStep3] = useState(initStep3Data('', '', '', '', '', '', '', ''));
  const [listOccupations, setListOccupations] = useState([]);
  const [listPositions, setListPositions] = useState([]);
  const dispatch = useDispatch();

  function handleValidatePhone(phone) {
    let result = validatePhone(phone);
    let step3Data;
    if (!result) {
      step3Data = { ...step3, refPhone: phone, isRefPhoneError: true };
      setStep3(step3Data);
      setRefPhoneErrorText("Error Reference Phone Format");
    } else {
      step3Data = { ...step3, refPhone: phone, isRefPhoneError: false };
      setStep3(step3Data);
      setRefPhoneErrorText("");
    }
    return step3Data;
  }

  function handleValidateName(name) {
    let result = validateName(name);
    let step3Data;
    if (!result) {
      step3Data = { ...step3, refName: name, isRefNameError: true };
      setStep3(step3Data);
      setRefNameErrorText("Error Reference Name Format");
    } else {
      step3Data = { ...step3, refName: name, isRefNameError: false };
      setStep3(step3Data);
      setRefNameErrorText("");
    }
    return step3Data;
  }

  function handleValidateSalary(salary) {
    let result = validateSalary(salary);
    let step3Data;
    if (!result) {
      step3Data = { ...step3, salary: salary, isSalaryError: true };
      setStep3(step3Data);
      setSalaryErrorText("Error Salary Format");
    } else {
      step3Data = { ...step3, salary: salary, isSalaryError: false };
      setStep3(step3Data);
      setSalaryErrorText("");
    }
    return step3Data;
  }

  function handleValidateCompany(company) {
    let result = validateCompany(company);
    let step3Data;
    if (!result) {
      step3Data = { ...step3, company: company, isCompanyError: true };
      setStep3(step3Data);
      setCompanyErrorText("Error Company Format");
    } else {
      step3Data = { ...step3, company: company, isCompanyError: false };
      setStep3(step3Data);
      setCompanyErrorText("");
    }
    return step3Data;
  }

  const handleChangeOccupation = (event) => {
    let value = event.target.value;
    let step3Data = { ...step3, occupation: value };
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangePosition = (event) => {
    let value = event.target.value;
    let step3Data = { ...step3, position: value };
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeSalary = (event) => {
    let value = event.target.value;
    let step3Data = handleValidateSalary(value);
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeCompany = (event) => {
    let value = event.target.value;
    let step3Data = handleValidateCompany(value);
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeReferenceName = (event) => {
    let value = event.target.value;
    let step3Data = handleValidateName(value);
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeReferencePhone = (event) => {
    let value = event.target.value;
    let step3Data = handleValidatePhone(value);
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeRefRelationship = (event) => {
    let value = event.target.value;
    let step3Data = { ...step3, relationship: value };
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  const handleChangeReferenceNote = (event) => {
    let value = event.target.value;
    let step3Data = { ...step3, refNote: value };
    setStep3(step3Data);
    props.onUpdateStep3Data(step3Data);
  };

  useEffect(() => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };

    const variablesOccupation = {
      "filter": {
        "isDelete": 0
      },
      "options": {
        "fetchAll": true
      }
    }

    const variablesPosition = {
      "filter": {
        "isDelete": 0
      },
      "options": {
        "fetchAll": true
      }
    }


    let promise1 = graphGetAllOccupations(variablesOccupation);
    let promise2 = graphGetAllPositions(variablesPosition);
    promise1.then(result => {
      setListOccupations(result.items);
    }).catch(function (error) {
      const err = JSON.parse(JSON.stringify(error))
      alert = { ...alert, message: err.response.errors[0].message };
      dispatch(showAlert(alert));
    });
    promise2.then(result => {
      setListPositions(result.items);
    }).catch(function (error) {
      const err = JSON.parse(JSON.stringify(error))
      alert = { ...alert, message: err.response.errors[0].message };
      dispatch(showAlert(alert));
    });
  }, [dispatch]);

  const renderOptionOcupation = listOccupations.map((item, i) => {
    return (
      <MenuItem value={item.id} key={i}>{item.occupationName}</MenuItem>
    );
  });

  const renderOptionPosition = listPositions.map((item, i) => {
    return (
      <MenuItem value={item.id} key={i}>{item.positionName}</MenuItem>
    );
  });

  const renderOptionRelationship = relationShip.map((item, i) => {
    return (
      <MenuItem value={item.id} key={i}>{item.name}</MenuItem>
    );
  });

  const renderReferenceComponent = (productType) => {
    return productType === 2 ? (
      <React.Fragment>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextField
            required
            id="refname"
            name="Refname"
            label="Reference Name"
            fullWidth
            autoComplete="given-name"
            variant="standard"
            error={step3.isRefNameError}
            helperText={refNameErrorText}
            onChange={handleChangeReferenceName}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <TextField
            required
            id="refphone"
            name="Refphone"
            label="Reference Phone"
            fullWidth
            autoComplete="given-name"
            variant="standard"
            error={step3.isRefPhoneError}
            helperText={refphoneErrorText}
            onChange={handleChangeReferencePhone}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl sx={formWidth} fullWidth>
            <InputLabel id="demo-simple-select-required-label">Relationship *</InputLabel>
            <Select
              required
              labelId="demo-simple-select-required-label"
              id="demo-simple-select-required"
              value={step3.relationship}
              label="Relationship "
              onChange={handleChangeRefRelationship}
            >
              {renderOptionRelationship}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <FormControl sx={formWidth} fullWidth>
            <TextField
              id="outlined-multiline-static"
              label="Reference Note"
              multiline
              value={step3.refNote}
              onChange={handleChangeReferenceNote}
            />
          </FormControl>
        </Grid>
      </React.Fragment>) : (<div></div>);
  }

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}>Confirm</Typography>
        <CheckIcon sx={iconColor}></CheckIcon>
      </Stack>
      <Grid container spacing={3} sx={container}>
        <Grid item xs={12} sm={12} md={12} sx={info}>
          <Typography variant="subtitle1" color={Color.Main}> Review previous information and provide additional information: </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={4}>
          <PreviousInformation step0Data={props.step0Data} step1Data={props.step1Data} step2Data={props.step2Data}></PreviousInformation>
        </Grid>
        <Grid item xs={12} sm={12} md={8}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl sx={formWidth} fullWidth>
                <InputLabel id="demo-simple-select-required-label">Occupation *</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-required-label"
                  id="demo-simple-select-required"
                  value={step3.occupation}
                  label="Occupation"
                  onChange={handleChangeOccupation}
                >
                  {renderOptionOcupation}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <FormControl sx={formWidth} fullWidth>
                <InputLabel id="demo-simple-select-required-label">Position *</InputLabel>
                <Select
                  required
                  labelId="demo-simple-select-required-label"
                  id="demo-simple-select-required"
                  value={step3.position}
                  label="Position"
                  onChange={handleChangePosition}
                >
                  {renderOptionPosition}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                required
                id="company"
                name="company"
                label="Company"
                fullWidth
                autoComplete="given-name"
                variant="standard"
                error={step3.isCompanyError}
                helperText={companyErrorText}
                onChange={handleChangeCompany}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <TextField
                required
                id="salary"
                name="salary"
                label="Salary"
                fullWidth
                autoComplete="given-name"
                variant="standard"
                error={step3.isSalaryError}
                helperText={salaryErrorText}
                onChange={handleChangeSalary}
                InputProps={{
                  inputComponent: MoneyFormatCustom
                }}
              />
            </Grid>
            {renderReferenceComponent(props.productType)}
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}